import React, { Component } from 'react';
import {
  Accordion,
  Button,
  Container,
  Divider,
  Dropdown,
  Grid,
  Loader,
  Progress
} from 'semantic-ui-react';
import _ from 'lodash';

import {
  updateUserPreferences,
  insertUserPreferences
} from '../../services/UserPreferencesManager';
import months from '../../utils/months';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import { getOnlyAdIds } from '../../fbApi/Ad';
import { retrieveAllAdsInfo } from '../../services/AdServiceManager';

class ProgressQCRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      accountOptions: props.accountOptions,
      adAccountName: null,
      adAccountId: null,
      campaignName: null,
      campaignIds: null,
      selectedCampaigns: [],
      accounts: null,
      selectedYear: '',
      showYearSelector: false,
      showYearLoader: false,
      years: [],
      formatSelected: null,
      showMonthSelector: false,
      showCampaignSelector: false,
      months: [],
      showMonthLoader: false,
      showCampaignsLoader: false,
      allCampaigns: [],
      token: props.getFbToken(),
      selectedMonth: {},
      filteredMonths: [],
      generalQCProgress: 0,
      generalTotalAds: 0,
      generalTotalQC: 0,
      qcProcess: {
        LINK_CLICKS: {
          totalAds: 0,
          totalQC: 0
        },
        VIDEO_VIEWS: {
          totalAds: 0,
          totalQC: 0
        },
        LEAD_GENERATION: {
          totalAds: 0,
          totalQC: 0
        },
        PRODUCT_CATALOG_SALES: {
          totalAds: 0,
          totalQC: 0
        },
        CONVERSIONS: {
          totalAds: 0,
          totalQC: 0
        },
        MESSAGES: {
          totalAds: 0,
          totalQC: 0
        },
        POST_ENGAGEMENT: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_TRAFFIC: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_SALES: {
          totalAds: 0,
          totalQC: 0
        }
      },
      loadingProgress: false,
      progressLoaded: false,
      hasUserPref: false,
      userPref: props.userPref
    };
  }
  componentDidMount() {
    if (this.state.userPref && this.state.userPref.user_email) {
      this.preSelectFields();
    }
  }
  onAccountSelect = (event, data) => {
    const account = _.find(
      data.options,
      (option) => option.value === data.value
    );
    const accountId = account.value;
    const accountName = account.text;
    this.selectAccount(accountId, accountName);
  };

  onYearSelect = (event, data) => {
    this.setState({
      showCampaignSelector: false,
      showNextMonthYear: false,
      generalQCProgress: 0,
      generalTotalAds: 0,
      generalTotalQC: 0,
      qcProcess: {
        LINK_CLICKS: {
          totalAds: 0,
          totalQC: 0
        },
        VIDEO_VIEWS: {
          totalAds: 0,
          totalQC: 0
        },
        LEAD_GENERATION: {
          totalAds: 0,
          totalQC: 0
        },
        PRODUCT_CATALOG_SALES: {
          totalAds: 0,
          totalQC: 0
        },
        CONVERSIONS: {
          totalAds: 0,
          totalQC: 0
        },
        MESSAGES: {
          totalAds: 0,
          totalQC: 0
        },
        POST_ENGAGEMENT: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_TRAFFIC: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_SALES: {
          totalAds: 0,
          totalQC: 0
        }
      }
    });

    const value = data.value;
    this.selectYear(value);
  };
  onMonthSelect = (event, data) => {
    const selectedMonth = _.find(
      data.options,
      (option) => option.value === data.value
    );
    this.selectMonth(null, selectedMonth).then(() => {
      const newUserPref = {
        ...this.state.userPref,
        [`month${this.props.index}`]: data.value,
        [`year${this.props.index}`]: this.state.selectedYear,
        [`account${this.props.index}`]: this.state.adAccountName
      };
      this.updateUserPreferences(newUserPref);
    });
  };
  getCampaigns = async (id) => {
    try {
      this.setState({
        campaigns: [],
        showYearLoader: true
      });
      const campaigns = await this.queryCampaigns(id);
      this.setState({
        campaigns: this.state.selectedCampaigns,
        showYearSelector: true,
        showYearLoader: false
      });

      return campaigns;
    } catch (error) {
      console.log(error);
    }
    return {};
  };

  getCampaignForMonth = async (campaignIds, token) => {
    const allCampaigns = await Promise.all(
      _.map(campaignIds, async (campaignId) => {
        const campaign = await getCampaign(campaignId, this.state.token);

        const campaignObjective = campaign.objective;
        const resultAds = await getOnlyAdIds(campaignId, token);
        const ads = resultAds.data;

        const previewObjects = ads.map(async (ad) => ({
          ad_id: ad.id,
          name: ad.name,
          campaignObjective
        }));

        return Promise.all(previewObjects);
      })
    );
    const ccm = {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };
    const qcProcess = {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      },
      MESSAGES: {
        totalAds: 0,
        totalQC: 0
      },
      POST_ENGAGEMENT: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_TRAFFIC: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_SALES: {
        totalAds: 0,
        totalQC: 0
      }
    };
    let totalAds = 0;
    const allIds = [];
    Object.keys(allCampaigns).forEach((k) => {
      totalAds += allCampaigns[k].length;
      allCampaigns[k].forEach((a) => allIds.push(a.ad_id));
    });
    _.forEach(allCampaigns, (c) => {
      if (c[0] && ccm[c[0].campaignObjective]) {
        ccm[c[0].campaignObjective] = ccm[c[0].campaignObjective].concat(c);
        qcProcess[c[0].campaignObjective].totalAds =
          ccm[c[0].campaignObjective].length;
      }
    });
    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));

    let totalQC = 0;
    allAdsInfo.ads.forEach((adPreview) => {
      if (
        adPreview.adData &&
        adPreview.adData !== null &&
        adPreview.adData.adQc &&
        adPreview.adData.adQc !== null
      ) {
        if (adPreview.adData.adQc.qc2) {
          Object.keys(allCampaigns).forEach((k) => {
            const ad = allCampaigns[k].find((a) => a.ad_id === adPreview.adId);
            if (ad) {
              qcProcess[ad.campaignObjective].totalQC += 1;
            }
          });
        }
      }
    });
    Object.keys(qcProcess).forEach((key) => {
      totalQC += qcProcess[key].totalQC;
    });
    const generalQCProgress = parseInt((totalQC * 100) / totalAds, 0);

    this.setState({
      qcProcess,
      generalQCProgress,
      generalTotalAds: totalAds,
      generalTotalQC: totalQC
    });
  };

  preSelectFields = async () => {
    if (this.state.userPref) {
      const accountValue = this.state.userPref[`account${this.props.index}`];
      if (!accountValue) return;
      const account = _.find(
        this.props.accounts,
        (a) => a.name && a.name.indexOf(accountValue) !== -1
      );

      if (account) {
        const campaigns = await this.selectAccount(
          account.account_id,
          account.name
        );
        const selectedYear = this.state.userPref[`year${this.props.index}`];

        if (selectedYear) {
          this.selectYear(selectedYear);
          const selectedMonth = this.state.userPref[`month${this.props.index}`];

          if (selectedMonth) {
            const month = _.find(
              campaigns,
              (c) => c.text && c.text.indexOf(selectedMonth) !== -1
            );
            this.selectMonth(month, month.text);
          }
        }
      }
    }
  };

  selectAccount = (accountId, accountName) => {
    this.setState({
      adAccountId: accountId,
      adAccountName: accountName,
      formats: null,
      campaignName: null,
      campaignIds: null,
      formatSelected: null,
      showCampaignSelector: false,
      selectedYear: '',
      showMonthSelector: false,
      filteredMonths: [],
      loadingProgress: false,
      progressLoaded: false
    });
    return this.getCampaigns(accountId);
  };

  selectYear = (value) => {
    const filteredCampaigns = this.state.campaigns.filter(
      (val) => val.year === value
    );
    const filteredMonths = this.state.months.filter((m) => m.year === value);
    this.setState({
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedYear: value,
      campaignName: '',
      filteredMonths,
      loadingProgress: false,
      progressLoaded: false
    });
  };

  selectMonth = async (month, selectedMonth) => {
    this.setState({
      selectedMonth,
      generalQCProgress: 0,
      generalTotalAds: 0,
      generalTotalQC: 0,
      qcProcess: {
        LINK_CLICKS: {
          totalAds: 0,
          totalQC: 0
        },
        VIDEO_VIEWS: {
          totalAds: 0,
          totalQC: 0
        },
        LEAD_GENERATION: {
          totalAds: 0,
          totalQC: 0
        },
        PRODUCT_CATALOG_SALES: {
          totalAds: 0,
          totalQC: 0
        },
        CONVERSIONS: {
          totalAds: 0,
          totalQC: 0
        },
        MESSAGES: {
          totalAds: 0,
          totalQC: 0
        },
        POST_ENGAGEMENT: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_TRAFFIC: {
          totalAds: 0,
          totalQC: 0
        },
        OUTCOME_SALES: {
          totalAds: 0,
          totalQC: 0
        }
      },
      loadingProgress: true,
      progressLoaded: false
    });
    let campaign = _.find(
      this.state.selectedCampaigns,
      (option) =>
        option.value.indexOf(selectedMonth.campaignsIds) !== -1 ||
        (option.text === selectedMonth &&
          option.year === this.state.selectedYear)
    );
    campaign = month || campaign;
    this.setState({
      campaignName: campaign.text,
      campaignIds: campaign.value
    });
    const token = this.state.token;

    await this.queryCampaigns(this.state.adAccountId);
    await this.getCampaignForMonth(campaign.value.split(','), token);

    this.setState({
      showFlipperButton: true,
      campaignName: campaign.text,
      campaignIds: campaign.value,
      showCampaignsLoader: false,
      showCampaignSelector: true,
      formatSelected: null,
      loadingProgress: false,
      progressLoaded: true
    });
  };
  queryCampaigns = async (id) => {
    const campaigns = await getCampaigns(id, this.state.token);
    const result = campaigns.data;

    const assocCampaigns = [];
    const campaignMonths = [];
    const years = [];

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);
      assocCampaigns[year + month] = {
        month_year: null,
        ids: []
      };
    });

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);

      const existentYear = years.filter((item) => item.text === year);

      if (existentYear.length === 0) {
        years.push({
          value: year,
          text: year
        });
      }

      assocCampaigns[year + month].month = month;
      assocCampaigns[year + month].year = year;
      assocCampaigns[year + month].ids.push(campaign.id);
    });

    _.mapKeys(assocCampaigns, (month) => {
      if (month) {
        campaignMonths.push(month);
      }
    });

    const campaignOptions = _.map(campaignMonths, (op, index) => {
      const month = months.filter((item) => item.shortName === op.month);

      return {
        key: index,
        value: op.ids.join(','),
        text: month[0] ? month[0].monthName : op.month,
        accountId: id,
        year: op.year
      };
    });

    const monthsOpt = _.map(campaignOptions, (op) => ({
      value: op.text,
      text: op.text,
      campaignsIds: op.value,
      year: op.year
    }));

    const filteredMonths = monthsOpt.filter(
      (m) => m.year === this.state.selectedYear
    );

    this.setState({
      selectedCampaigns: campaignOptions,
      filteredCampaigns: campaignOptions,
      data: result,
      years,
      months: monthsOpt,
      filteredMonths
    });

    return campaignOptions;
  };
  updateUserPreferences = async (newUserPref) => {
    if (this.state.hasUserPref) {
      updateUserPreferences(newUserPref);
      this.setState({
        userPref: newUserPref
      });
    } else {
      const insertUserPref = {
        ...newUserPref,
        user_email: this.props.user.email
      };
      insertUserPreferences(insertUserPref);
      this.setState({
        hasUserPref: true,
        userPref: insertUserPref
      });
    }
  };
  refreshAll = () => {
    if (this.state.progressLoaded) {
      this.selectMonth(null, this.state.selectedMonth);
    }
  };
  renderMonthDropDown = () => {
    if (this.state.showMonthSelector) {
      return (
        <div>
          <Dropdown
            placeholder="Month"
            search
            selection
            value={this.state.campaignName}
            disabled={this.state.processing}
            options={this.state.filteredMonths}
            onChange={this.onMonthSelect}
          />
        </div>
      );
    } else if (this.state.showMonthLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  renderYearSelector = () => {
    if (this.state.showYearSelector) {
      return (
        <Dropdown
          placeholder="Year"
          disabled={this.state.processing}
          search
          selection
          options={this.state.years}
          value={this.state.selectedYear}
          onChange={this.onYearSelect}
        />
      );
    } else if (this.state.showYearLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };
  renderProgressOrLoader = () => {
    const campaignList = {
      LINK_CLICKS: 'Traffic Ads',
      VIDEO_VIEWS: 'Video Ads',
      LEAD_GENERATION: 'Lead Generation',
      PRODUCT_CATALOG_SALES: 'Dynamic Ads',
      CONVERSIONS: 'Engagement Ads',
      MESSAGES: 'Messenger Ads',
      POST_ENGAGEMENT: 'Post Engagement',
      OUTCOME_TRAFFIC: 'Outcome Traffic',
      OUTCOME_SALES: 'Outcome Sales'
    };
    if (this.state.loadingProgress) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    } else if (this.state.progressLoaded) {
      return (
        <Accordion>
          <Accordion.Title
            active={this.state.active}
            onClick={() => {
              this.setState({ active: !this.state.active });
            }}
          >
            <Progress
              percent={this.state.generalQCProgress}
              color="green"
              progress
              label={`${this.state.generalTotalQC}/${this.state.generalTotalAds}`}
            />
          </Accordion.Title>
          <Accordion.Content active={this.state.active}>
            {Object.keys(this.state.qcProcess).map((key) => {
              if (this.state.qcProcess[key].totalAds > 0) {
                return (
                  <div>
                    <span>{campaignList[key]}</span>
                    <Progress
                      size="tiny"
                      percent={
                        this.state.qcProcess[key]
                          ? parseInt(
                              (this.state.qcProcess[key].totalQC * 100) /
                                this.state.qcProcess[key].totalAds,
                              0
                            )
                          : 0
                      }
                      color="green"
                      label={`${this.state.qcProcess[key].totalQC}/${this.state.qcProcess[key].totalAds}`}
                    />
                  </div>
                );
              }
              return null;
            })}
          </Accordion.Content>
        </Accordion>
      );
    }
    return null;
  };
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Button
              disabled={!this.state.progressLoaded}
              onClick={() => {
                this.refreshAll();
              }}
            >
              Refresh
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <Dropdown
              placeholder="Ad Accounts"
              search
              selection
              value={this.state.adAccountId}
              disabled={this.state.processing}
              options={this.props.accountOptions}
              onChange={this.onAccountSelect}
            />
            <Divider hidden />
            {this.renderYearSelector()}
            <Divider hidden />
            {this.renderMonthDropDown()}
            <Divider hidden />
          </Grid.Column>
          <Grid.Column width={12}>{this.renderProgressOrLoader()}</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ProgressQCRow;



// WEBPACK FOOTER //
// ./src/screens/QCSummary/ProgressQCRow.js